export const isProduction = true;

export const rpcUrl = isProduction ? 'https://bsc-dataseed.binance.org/' : 'https://data-seed-prebsc-1-s1.binance.org:8545/';
export const scannerUrl = isProduction ? 'https://bscscan.com' : 'https://testnet.bscscan.com';
